// API configuration
// TODO: This is a hack that makes test / production builds work.
// We need a way to inject the correct API url at runtime instead
export const API_BASE_URL =
  import.meta.env.VITE_API_URL || `${window.location.origin}/api`

export const getApiUrl = (endpoint: string) => {
  // Remove trailing slash from base URL if present
  const baseUrl = API_BASE_URL.endsWith('/')
    ? API_BASE_URL.slice(0, -1)
    : API_BASE_URL

  // Remove leading slash from endpoint if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint

  return `${baseUrl}/${cleanEndpoint}`
}
